import React from "react";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import {
  Container,
  Text,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";

const Construction = () => {
  return (
    <Container>
      <Menu />
      <Banner icon={images.iconConheca}>EM CONSTRUÇÃO</Banner>
      <ContentBox>
        
          <Text>
            Aguarde!
          </Text>
          
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default Construction;